import { where } from "firebase/firestore";
import { BaseApi } from "../user/BaseApi";

/**
 * CURD
 */

class GroupApi extends BaseApi {
  constructor() {
    const defaultEntity = {
      description: "",
      name: "",
      daoTrang: "",

      //array of user.email
      leader: "",
      subLeader: [],
      members: [],
      beginner: [],
    };
    super("groups", defaultEntity);
  }

  async getAllGroups(daoTrangId) {
    return await this.query(where("daoTrang", "==", daoTrangId));
  }
}

// class GroupApi_REST extends GroupApi {
//   constructor() {
//     super();
//     this.restApi = new CommonApi("groups");
//   }
//   async create(group, token) {
//     return this.restApi.postOne(token, group);
//   }
//   async update(id, changes, token) {
//     return this.restApi.patchOne(token, id, changes);
//   }
//   async save(group, token) {
//     return this.restApi.patchOne(token, group.id, group);
//   }
//   async remove(id, token) {
//     return this.restApi.deleteOne(token, id);
//   }

//   async getAllGroups(daoTrangId, token) {
//     return await this.query(where("daoTrang", "==", daoTrangId));
//     let config = {
//       method: "post",
//       maxBodyLength: Infinity,
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: "Bearer " + token,
//       },
//       data: JSON.stringify({
//         query: `query Me {
//           me {
//               account
//               role
//           }
//       }`,
//       }),
//     };
//     return await requestG(config);
//   }

//   // user for migrate
//   async saveOrCreate(group, token) {
//     var {result} = await this.restApi.postOne(token, group);
//     if (result) {
//       return {result};
//     }
//     else {
//       return this.restApi.patchOne(token, group.id, group);
//     }
//   }
// }

// const groupApi = process.env.USE_REST_API ? new GroupApi_REST():new GroupApi();
var groupApi = new GroupApi()


function format(g) {
  var { leader, subLeader, members, ...rest } = g;
  return {
    ...rest,
    subGroups: [
      {
        name: "leader",
        members: leader ? [leader] : [],
      },
      {
        name: "subLeader",
        members: subLeader,
      },
      {
        name: "members",
        members: members,
      },
    ],
  };
}
export function parse(f) {
  var { subGroups, ...rest } = f;
  var [leader, subLeader, members, beginner] = subGroups;
  var obj = {
    ...rest,
    leader: leader.members[0] ? leader.members[0] : "",
    subLeader:subLeader.members,
    members:members.members,
  };
  Object.keys(obj).forEach((k) => obj[k] === undefined && delete obj[k]);
  return obj;
}
function transform(cb, f=(o)=>format(o)) {
  return async (a, b, c) => {
    var { error, result } = await cb(a, b, c);
    if (!error) {
      return { result: f(result) };
    } else {
      return { error };
    }
  };
}
export const getAllGroups = async (daoTrangId, token) => {
  var { error, result } = await groupApi.getAllGroups(daoTrangId, token);
  if (!error) {
    return { result: result.map((o) => format(o)) };
  } else {
    return { error };
  }
};
export const getAllGroups2 = (daoTrangId) =>
  transform(groupApi.getAllGroups)(daoTrangId, (a)=>a.map((o) => format(o)));

export const createGroup = async (group, token) => {
  var { error, result } = await groupApi.create(parse(group), token);
  if (!error) {
    return { result: format(result) };
  } else {
    return { error };
  }
};
// export const createGroup2 = (group) => transform(groupApi.create)(parse(group));
// export const updateGroup = (id, changes) => transform(groupApi.update)(id, parse(changes));
export const saveGroup = async (group) => {
  console.log({group})
  return;
  var { error, result } = await groupApi.save(parse(group));
  if (!error) {
    return { result: format(result) };
  } else {
    return { error };
  }
};
// export const saveGroup2 = (group) => transform(groupApi.save)(parse(group));
export const removeGroup = (id, token) => transform(groupApi.remove)(id, token);
export const saveOrCreateGroup = async (group, token) => {
  console.log({group})
  var { error, result } = await groupApi.saveOrCreate(parse(group), token);
  if (!error) {
    return { result: format(result) };
  } else {
    return { error };
  }
};
// export const saveOrCreateGroup2 = (group) => transform(groupApi.saveOrCreate)(parse(group));
export const newDefaultGroup = () => format({ ...groupApi.defaultEntity });
